export class ScriptLinkItem {
  name: string;
  subName: string;
  objectId: string;
  itemName: string;
  value: string;
  claioImageId: string;
  cacheImageGuid: string;
  externalImageId: string;

  clone(): ScriptLinkItem {
    const cloned = new ScriptLinkItem();
    cloned.name = this.name;
    cloned.subName = this.subName;
    cloned.objectId = this.objectId;
    cloned.itemName = this.itemName;
    cloned.value = this.value;
    cloned.claioImageId = this.claioImageId;
    cloned.cacheImageGuid = this.cacheImageGuid;
    cloned.externalImageId = this.externalImageId;
    return cloned;
  }
}
